import React, { useState } from "react";

import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import MedicalWireframePicker from "../Components/MedicalWireframePicker";
import MedicalUxVersion from "../Types/MedicalUxVersion";
import ComposedAllMedicalQuestionsStep from "./ComposedAllMedicalQuestionsStep";

const uxVersionComponents: Record<MedicalUxVersion, React.FC<IStepWrapperButtonProps>> = {
  [MedicalUxVersion.CombinedPage]: ComposedAllMedicalQuestionsStep
};

/** Decorator for the medical step that renders a wireframe UX picker on every page load.
 * Once a version is selected the matching step component is rendered in its place for the current session.
 * Wrap removal: replace this component with ComposedAllMedicalQuestionsStep at the app/medical route.
 */
const ComposedMedicalWireframePickerStep: React.FC<IStepWrapperButtonProps> = props => {
  const [selectedVersion, setSelectedVersion] = useState<MedicalUxVersion | null>(null);

  if (selectedVersion !== null) {
    const SelectedStep = uxVersionComponents[selectedVersion];
    return <SelectedStep {...props} />;
  }

  return <MedicalWireframePicker onSelect={setSelectedVersion} />;
};

export default ComposedMedicalWireframePickerStep;
